export default "__VITE_ASSET__DdY8DGn2__"